import { Button, Modal, Box, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  footerButtonWidth,
  cancelButtonStyles,
  registerPatientButtonStyles,
} from "../../common/commonStyles";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import { format } from "date-fns";

const BranchCreationForm = ({
  open,
  handleClose,
  formData,
  setFormData,
  handleInputChange,
  handleCreateBranch,
  validationErrors,
  isEditClicked,
}) => {
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            flexGrow: 1,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "800px",
            maxWidth: "800px",
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Grid container>
            <Grid item xs={12}>
              <h3 className="form-title">
                {isEditClicked ? "Edit Branch" : "Branch Creation Form"}
              </h3>
            </Grid>
          </Grid>
          <Divider sx={{ marginBottom: "20px" }} />
          <Grid container spacing={2}>
            <Grid size={8}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  margin="normal"
                  label="Branch Name"
                  name="name"
                  size="small"
                  value={formData.name}
                  onChange={handleInputChange}
                  autoComplete="off"
                  className="custom-textfield"
                  error={!!validationErrors.name}
                  helperText={validationErrors.name}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  margin="normal"
                  multiline
                  maxRows={4}
                  label="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  autoComplete="off"
                  className="custom-textfield"
                  error={!!validationErrors.address}
                  helperText={validationErrors.address}
                />
              </Grid>
              <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={6}>
                  <TextField
                    required
                    margin="normal"
                    label="Country"
                    name="country"
                    size="small"
                    value={formData.country}
                    onChange={handleInputChange}
                    sx={{ width: "25ch" }}
                    autoComplete="off"
                    className="custom-textfield"
                    error={!!validationErrors.country}
                    helperText={validationErrors.country}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    margin="normal"
                    label="City"
                    name="city"
                    size="small"
                    value={formData.city}
                    onChange={handleInputChange}
                    sx={{ width: "25ch" }}
                    autoComplete="off"
                    className="custom-textfield"
                    error={!!validationErrors.city}
                    helperText={validationErrors.city}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <TextField
                    required
                    margin="normal"
                    label="Postal Code"
                    name="postal_code"
                    size="small"
                    value={formData.postal_code}
                    onChange={handleInputChange}
                    sx={{ width: "25ch" }}
                    autoComplete="off"
                    className="custom-textfield"
                    error={!!validationErrors.postal_code}
                    helperText={validationErrors.postal_code}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <TextField
                    required
                    margin="normal"
                    label="Contact Number"
                    name="contact_number"
                    size="small"
                    value={formData.contact_number}
                    onChange={handleInputChange}
                    sx={{ width: "25ch" }}
                    autoComplete="off"
                    className="custom-textfield"
                    error={!!validationErrors.contact_number}
                    helperText={validationErrors.contact_number}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={4}>
              <Grid container spacing={0} sx={{ justifyContent: "end" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    label="Start Time *"
                    value={
                      formData?.start_time
                        ? new Date(`1970-01-01T${formData.start_time}`)
                        : null
                    }
                    onChange={(newValue) =>
                      setFormData((prev) => ({
                        ...prev,
                        start_time: newValue
                          ? format(newValue, "HH:mm:ss")
                          : null,
                      }))
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                    sx={{ m: 1, width: "20ch" }}
                    className="custom-timepicker"
                  />
                  <TimePicker
                    label="End Time *"
                    value={
                      formData?.close_time
                        ? new Date(`1970-01-01T${formData.close_time}`)
                        : null
                    }
                    onChange={(newValue) =>
                      setFormData((prev) => ({
                        ...prev,
                        close_time: newValue
                          ? format(newValue, "HH:mm:ss")
                          : null,
                      }))
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                    sx={{ m: 1, width: "20ch" }}
                  />
                  <TimePicker
                    label="Break Start Time *"
                    value={
                      formData?.break_start_time
                        ? new Date(`1970-01-01T${formData.break_start_time}`)
                        : null
                    }
                    onChange={(newValue) =>
                      setFormData((prev) => ({
                        ...prev,
                        break_start_time: newValue
                          ? format(newValue, "HH:mm:ss")
                          : null,
                      }))
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                    sx={{ m: 1, width: "20ch" }}
                  />
                  <TimePicker
                    label="Break End Time *"
                    value={
                      formData?.break_end_time
                        ? new Date(`1970-01-01T${formData.break_end_time}`)
                        : null
                    }
                    onChange={(newValue) =>
                      setFormData((prev) => ({
                        ...prev,
                        break_end_time: newValue
                          ? format(newValue, "HH:mm:ss")
                          : null,
                      }))
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                    sx={{ m: 1, width: "20ch" }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <div className="register_btn">
            <Button
              className="create_form_btn"
              variant="contained"
              sx={[registerPatientButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleCreateBranch();
              }}
            >
              {isEditClicked ? "Edit" : "Create"}
            </Button>
            <Button
              className="create_form_btn"
              variant="contained"
              sx={[cancelButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleClose();
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default BranchCreationForm;
